module.exports = __webpack_public_path__ + "static/media/loader-2.2cb4aee2.svg";